import React, { useEffect, useState } from "react";
import "../css/donations.scss";
import { get_dontion_list } from "../apis/GetDontionList.js";
import { LIST_URL } from "../constans/ApiEndpointConstants.js";
import { generateDonationUrl } from "../utils/urlUtils";
import { useNavigate } from "react-router-dom";
import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";
import Loading from "./common/Loading.js";

const AllDonations = () => {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 8; // Increased for 4-column layout
  const navigate = useNavigate();

  const storedAd = LocalStorageUtil.getAd();
  const ad = storedAd || "donation";

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [All_Donations page]:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  }, [ad]);

  useEffect(() => {
    const fetchList = async () => {
      setLoading(true);
      try {
        const resp = await get_dontion_list(page, perPage, "JP");
        const data = resp?.data ?? resp ?? [];
        const list = data.projects || (Array.isArray(data) ? data : []);
        setDonations(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Failed to load donations list:", err);
        setDonations([]);
      } finally {
        setLoading(false);
      }
    };
    fetchList();
  }, [page]);

  // keep current page valid when donations change
  useEffect(() => {
    const totalPages = Math.max(
      1,
      Math.ceil((donations?.length || 0) / perPage)
    );
    if (page > totalPages) setPage(totalPages);
  }, [donations, page]);

  const parseAmount = (val) => {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const s = String(val).replace(/[^0-9.-]+/g, "");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const computeProgress = (item) => {
    if (!item) return 0;
    const raised = parseAmount(
      item.raised ?? item.raised_amount ?? item.raisedAmount
    );
    const goal = parseAmount(item.goal ?? item.goal_amount ?? item.goalAmount);
    if (goal > 0) return Math.max(0, Math.min(1, raised / goal));
    return 0;
  };

  const resolveImageUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    const base = LIST_URL.endsWith("/") ? LIST_URL.slice(0, -1) : LIST_URL;
    return raw.startsWith("/") ? base + raw : base + "/" + raw;
  };

  if (loading) {
    return (
      <div className="donations">
        <Loading />
      </div>
    );
  }

  const totalPages = Math.max(1, Math.ceil((donations?.length || 0) / perPage));
  const startIdx = (page - 1) * perPage;
  const visibleDonations = donations.slice(startIdx, startIdx + perPage);

  return (
    <>
      <Header />
      {loading ? (
        <Loading />
      ) : (
        <section className="donations donations--all">
          <div className="donations__inner">
            <div className="donations__header">
              <div className="filter-tabs">
                <span className="filter-label">すべての寄付一覧</span>
              </div>
            </div>

            <div className="donations__grid donations__grid--all">
              {donations.length === 0 && (
                <div style={{ padding: 24 }}>寄付は見つかりませんでした。</div>
              )}
              {visibleDonations.map((d, idx) => (
                <article
                  className="donations__card"
                  key={idx}
                  onClick={() => {
                    const url = generateDonationUrl(d);
                    if (url) navigate(url);
                  }}
                >
                  <div className="card">
                    <div className="card__img-wrap">
                      <img
                        src={resolveImageUrl(d.image?.[0]?.url || d.img || "")}
                        alt={d.title}
                      />
                    </div>

                    <h4 className="card__title">{d.title}</h4>

                    <div className="card__organizer">
                      <div className="organizer-icon">
                        {d.avatar ? (
                          <img
                            src={resolveImageUrl(d.avatar)}
                            alt=""
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <svg
                            t="1763521333448"
                            className="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="2441"
                            width="100%"
                            height="100%"
                          >
                            <path
                              d="M506.4704 606.0032a204.8 204.8 0 1 1 201.5232-204.8 203.5712 203.5712 0 0 1-201.5232 204.8z m0-386.4576a181.4528 181.4528 0 1 0 177.8688 181.3504 179.9168 179.9168 0 0 0-177.8688-181.4528z"
                              p-id="2442"
                            ></path>
                            <path
                              d="M506.4704 611.1232a210.2272 210.2272 0 1 1 206.6432-210.2272 208.6912 208.6912 0 0 1-206.6432 210.2272z m0-409.6a199.9872 199.9872 0 1 0 196.4032 199.3728 198.4512 198.4512 0 0 0-196.4032-199.8848z m0 386.4576a186.5728 186.5728 0 1 1 182.9888-187.0848 185.0368 185.0368 0 0 1-182.9888 186.5728z m0-362.9056a176.3328 176.3328 0 1 0 172.7488 175.8208 174.7968 174.7968 0 0 0-172.7488-176.3328z"
                              p-id="2443"
                            ></path>
                            <path
                              d="M771.7888 812.8512a11.776 11.776 0 0 1-11.264-8.3968 264.704 264.704 0 0 0-508.2112 0 11.776 11.776 0 1 1-22.528-6.8608 288.3584 288.3584 0 0 1 552.96 0 11.776 11.776 0 0 1-11.264 15.2576z"
                              p-id="2444"
                            ></path>
                            <path
                              d="M241.0496 817.9712A16.896 16.896 0 0 1 225.28 796.16a293.4784 293.4784 0 0 1 563.2 0 16.896 16.896 0 0 1-11.264 21.0944 17.2032 17.2032 0 0 1-21.0944-11.264 259.584 259.584 0 0 0-498.3808 0 16.9984 16.9984 0 0 1-16.6912 11.9808z m265.4208-222.3104A283.8528 283.8528 0 0 0 234.5984 798.72a6.656 6.656 0 1 0 12.8 3.8912 269.824 269.824 0 0 1 518.0416 0 6.9632 6.9632 0 0 0 8.2944 4.4032A6.656 6.656 0 0 0 778.24 798.72a283.8528 283.8528 0 0 0-271.7696-203.0592z"
                              p-id="2445"
                            ></path>
                          </svg>
                        )}
                      </div>
                      <span>{d.name || "主催者"}</span>
                    </div>

                    <div className="card__stats">
                      <div className="progress-bar">
                        <div
                          className="progress-bar__fill"
                          style={{ width: `${computeProgress(d) * 100}%` }}
                        >
                          <span className="progress-bar__text">
                            {Math.round(computeProgress(d) * 100)}%
                          </span>
                        </div>
                      </div>
                      <div className="stats-row details">
                        <div className="stat-item">
                          <span className="label">現在</span>
                          <span className="value">
                            {parseAmount(
                              d.raised ?? d.raised_amount ?? d.raisedAmount
                            ).toLocaleString()}
                            円
                          </span>
                        </div>
                        <div className="stat-item">
                          <span className="label">支援者</span>
                          <span className="value">
                            {d.supporters || Math.floor(Math.random() * 100)}人
                          </span>
                        </div>
                        <div className="stat-item">
                          <span className="label">残り</span>
                          <span className="value">
                            {d.daysLeft || Math.floor(Math.random() * 30)}日
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
            {donations.length > perPage && (
              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  className="pagination"
                  role="navigation"
                  aria-label="Pagination"
                >
                  <button
                    className="pagination__btn"
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page <= 1}
                    aria-label="Previous page"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M15 18l-6-6 6-6"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  {/* page number buttons (show window of pages) */}
                  {(() => {
                    const pages = [];
                    const maxButtons = 7;
                    let start = Math.max(1, page - Math.floor(maxButtons / 2));
                    let end = start + maxButtons - 1;
                    if (end > totalPages) {
                      end = totalPages;
                      start = Math.max(1, end - maxButtons + 1);
                    }
                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`pagination__btn page-number ${
                            i === page ? "is-active" : ""
                          }`}
                          onClick={() => setPage(i)}
                          aria-current={i === page ? "page" : undefined}
                        >
                          {i}
                        </button>
                      );
                    }
                    return pages;
                  })()}

                  <button
                    className="pagination__btn"
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page >= totalPages}
                    aria-label="Next page"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M9 6l6 6-6 6"
                        stroke="#000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      )}

      <Footer />
    </>
  );
};

export default AllDonations;
